export const REQUEST_ROOMS_LIST = '@ROOMS/REQUEST_ROOMS_LIST'
export const SET_ROOMS_LIST = '@ROOMS/SET_ROOMS_LIST'
export const SET_PAGE = '@ROOMS/SET_PAGE'
export const REQUEST_DELETE_ROOM = '@ROOMS/REQUEST_DELETE_ROOM'

export const OPEN_MODAL_CREATE_CHANNEL = '@ROOMS/OPEN_MODAL_CREATE_CHANNEL'
export const REQUEST_CREATE_CHANNEL = '@ROOMS/REQUEST_CREATE_CHANNEL'
export const SUCCESS_CREATE_CHANNEL = '@ROOMS/SUCCESS_CREATE_CHANNEL'
export const CLOSE_MODAL_CREATE_CHANNEL = '@ROOMS/CLOSE_MODAL_CREATE_CHANNEL'
